export default "__VITE_ASSET__CLx2WytY__"